exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{background:#f8f8f8;font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif;box-sizing:border-box;color:#353c45;max-width:100vw;margin:0}body,main{position:relative}main{z-index:10000}.scroller{width:352px;box-sizing:border-box;position:absolute;right:0;top:0}@media (max-width:768px){body{overflow:scrollY}body,main{width:100%}main h1{text-align:center}.scroller{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c1b036f","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RelatedContent.vue
// module id = 251
// module chunks = 0